import { render, staticRenderFns } from "./StepPhotoFin.vue?vue&type=template&id=53159c1a"
import script from "./StepPhotoFin.vue?vue&type=script&lang=js"
export * from "./StepPhotoFin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports